function decodeBase64Url(value) {
  const normalized = value.replaceAll('-', '+').replaceAll('_', '/');
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
  return decodeURIComponent(
    atob(padded)
      .split('')
      .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`)
      .join(''),
  );
}

export function normalizeToken(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function readJwtPayload(token) {
  const normalized = normalizeToken(token);
  const parts = normalized.split('.');
  if (parts.length !== 3) return null;
  try {
    return JSON.parse(decodeBase64Url(parts[1]));
  } catch {
    return null;
  }
}

export function isValidAdminAccessToken(token, clockSkewMs = 5_000) {
  const payload = readJwtPayload(token);
  if (!payload) return false;
  return payload.role === 'admin'
    && payload.tokenType === 'access'
    && typeof payload.sub === 'string'
    && typeof payload.sid === 'string'
    && typeof payload.exp === 'number'
    && payload.exp * 1_000 > Date.now() + clockSkewMs;
}

export function normalizeAdminSession(input) {
  const accessToken = normalizeToken(input?.accessToken);
  const expiresInSeconds = Number(input?.expiresInSeconds) || 0;
  return {
    accessToken,
    admin: input?.admin ?? null,
    sessionId: typeof input?.sessionId === 'string' ? input.sessionId : null,
    expiresInSeconds,
    expiresAt: Date.now() + Math.max(0, expiresInSeconds) * 1_000,
  };
}
